
import {
  defineComponent,
  ref,
  useContext,
  computed,
} from '@nuxtjs/composition-api'
import { Route } from 'vue-router'

export default defineComponent({
  props: ['params'],
  setup() {
    const {
      app: { i18n, router },
    } = useContext()

    const languageSwitch = ref(false)

    const availableLocales = computed(() => i18n.locales)

    const breadcrumb = computed(() => {
      const breadcrumbList: object[] = []

      if (typeof router === 'object') {
        const fullPath: string = router.currentRoute.fullPath

        const params: string[] = fullPath.startsWith('/')
          ? fullPath.substring(1).split('/')
          : fullPath.split('/')

        let path: string = ''

        params.forEach((param: string) => {
          if (param !== '') {
            path = `${path}/${param}`
            if (typeof router === 'object') {
              const match: Route = router.resolve(path + '/').route
              if (typeof match.name === 'string') {
                let page: string = match.name.substr(0, match.name.length - 5)

                /**
                 * Wishlist
                 */

                page = page.replace('wishlistDetails', 'wishlist')

                /**
                 *
                 */

                if (!(page === 'index' && params.length > 1)) {
                  breadcrumbList.push({
                    pageName: page,
                    ...match,
                  })
                }
              }
            }
          }
        })
      }

      return breadcrumbList
    })

    return { languageSwitch, availableLocales, breadcrumb }
  },
})
